<template>
  <div>
    <component-header
      title="Notification Approval Details"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/approvalNotification')"
    />
    <b-card>
      <div class="status-header-wrapper">
        <h4 class="status-header">
          Status :
          <span
            class="span-text status-approved"
            v-if="bulkNotificationData.status == 'APPROVED'"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text status-rejected"
            v-if="bulkNotificationData.status == 'REJECTED'"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text status-pending"
            v-if="bulkNotificationData.status == 'PENDING'"
            >{{ bulkNotificationData.status }}</span
          >
        </h4>
      </div>
      <div>
        <b-row>
          <b-col cols="12" md="8" class="pb-0"
            ><h4 class="mx-3 section-title-primary">Filter Criteria</h4></b-col
          >
          <b-col cols="12" md="4" class="pb-0"
            ><h4 class="mx-3 section-title-primary">Search Criteria</h4></b-col
          >
        </b-row>
        <b-row class="mt-0 criteria-details-row">
          <b-col cols="12" md="5" class="mt-2">
          <div class="mx-3">
           <div class="d-flex align-items-center mb-2 form-field-row">
               <label class="text-dark font-weight-bold form-label-fixed">
               Created Date:
              </label>
             <input type="text" class="form-control" v-model="bulkNotificationData.createdAt" />
           </div>
           <div class="d-flex align-items-center mb-2 form-field-row">
              <label class="text-dark font-weight-bold form-label-fixed">
              Collection Name:
              </label>
             <input type="text" class="form-control" v-model="bulkNotificationData.criteria.collectionName" />
           </div>
           <div class="d-flex align-items-center mb-2 form-field-row">
              <label class="text-dark font-weight-bold form-label-fixed">
              Count:
              </label>
             <input type="number" class="form-control" v-model="bulkNotificationData.criteria.count" />
           </div>
          <div class="d-flex align-items-center mb-2 form-field-row">
            <label class="text-dark font-weight-bold form-label-fixed">
             Status:
           </label>
            <input type="text" class="form-control" v-model="bulkNotificationData.criteria.status" />
          </div>
          <div class="d-flex align-items-center mb-2 form-field-row">
         <label class="text-dark font-weight-bold form-label-fixed">
          URL:
        </label>
        <a
         :href="bulkNotificationData && bulkNotificationData.criteria ? bulkNotificationData.criteria.url : ''"
         class="btn btn-primary w-100 download-link-btn"
         target="_blank"
         rel="noopener noreferrer"
        >
        Download
        </a>
      </div>
         </div>
          </b-col>
          <b-col cols="12" md="7" class="mt-2 mt-md-0">
            <b-table
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="approvalNotificationFilter"
              :fields="criteriaColumns"
              thead-class="header"
              show-empty
            >
            <template #cell(name)="data">
              <b class="text-info">{{ data.value.last.toUpperCase() }}</b>, <b>{{ data.value.first }}</b>
            </template>
            </b-table>
            <!-- <div class="mx-3">
              <h5 class="h5-text">
                Value :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0] &&
                  bulkNotificationData.criteria.filterBy[0].data
                    ? bulkNotificationData.criteria.filterBy[0].data.value
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Field :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0]
                    ? bulkNotificationData.criteria.filterBy[0].field
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Filter :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0]
                    ? bulkNotificationData.criteria.filterBy[0].filter
                    : ""
                }}</span>
              </h5> 
            </div> -->
          </b-col>
        </b-row>
        <hr class="hr-border-dashed-primary mt-2 my-3" />
       <h4 class="mx-3 section-title-primary">Template Configuration</h4>
<b-row class="template-config-row">
  <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Description :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.description"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Notification Type :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.notificationType"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Schedule Date & Time :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.scheduleDate | formateScheduleDate"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Scheduler Status :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.schedulerStatus"
        />
      </div>
    </div>
  </b-col>

  <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Status :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.status"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Concern :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.concern : ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Name :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.name : ''"
        />
      </div>
    </div>
  </b-col>

  <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Notification Pending :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.pending || ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Notification Success :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.success || ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Notification Failed :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.failed || ''"
        />
      </div>
    </div>
  </b-col>

  <b-col cols="12" md="12" class="mb-3">
    <div class="mx-3">
      <div class="d-flex align-items-start mb-2 form-field-row">
        <label class="text-dark font-weight-bold mr-2 form-label-medium">Body :</label>
        <textarea
          class="form-control template-body-textarea"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.body : ''"
        ></textarea>
      </div>
    </div>
  </b-col>
</b-row>
        <div
          class="text-center mb-5 mt-2 p-4 approval-buttons-wrapper"
          v-if="bulkNotificationData.status === 'PENDING'"
        >
          <b-row class="justify-content-center">
            <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 mb-sm-0">
              <button
                type="button"
                class="btn btn-lg btn-outline-danger w-100 approval-btn-reject"
                @click="approvalStatus(bulkNotificationData._id, 'REJECTED')"
              >
                REJECT
              </button>
            </b-col>
            <b-col cols="12" sm="6" md="4" lg="3">
              <button
                type="button"
                class="btn btn-lg btn-outline-success w-100 approval-btn-approve"
                @click="approvalStatus(bulkNotificationData._id, 'APPROVED')"
              >
                APPROVE
              </button>
            </b-col>
          </b-row>
        </div>
        <div class="text-center mb-5 mt-3" v-else>
          <button
            type="button"
            class="btn btn-sm btn-primary mr-3 status-display-btn"
            :disabled="true"
          >
            {{ bulkNotificationData.status }}
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import currentUser from "@/mixins/currentUser";

export default {
  name: "approvalNotificationDetails",
  components: {
    ComponentHeader,
  },
  data() {
    return {
      isloading: false,
      bulkNotificationData: [],
      small: false,
      fixed: false,
      bordered: true,
      striped: false,
      criteriaColumns: [
        {
          key: "field",
          label: "Field",
        },
        {
          key: "filter",
          label: "Filter",
          sortable: true,
        },
        {
          key: "value.value",
          label: "Value",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      GetFetchBulkNotificationList:
        "approvalNotificationBulk/GetFetchBulkNotificationList",
    }),
    approvalNotificationList() {
      return this.GetFetchBulkNotificationList;
    },
    approvalNotificationFilter() {
      const allFilter = this.bulkNotificationData?.criteria?.filterBy?.map(
        (criteria) => {
          if (criteria.filter !== "date") {
            let showData = {
              value: criteria.data,
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          } else {
            let showData = {
              value: {value: `${criteria.data.gte} To ${criteria.data.lte}`},
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          }
        }
      );
      return allFilter;
    },
  },

  methods: {
    async approvalStatus(id, status) {
      let payload = {
        id: id,
        status: status,
      };
      await this.$store
        .dispatch("approvalNotificationBulk/updateApprovalNoti", payload)
        .then((data) => {
          if (data.status === 1) {
            this.bulkNotificationData = {};
            this.$swal({
              title: "Success",
              text: `Approval Request ${status}`,
              type: "success",
            });
            this.$router.push("/approvalNotification");
          }
        })
        .catch((e) => {});
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
    formateScheduleDate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
  mounted: async function () {
    this.loading = true;
    let payload = {
      status: "",
      fromDate: "",
      toDate: "",
    };
    await this.$store.dispatch(
      "approvalNotificationBulk/fetchBulkNotificationList",
      payload
    );
    this.bulkNotificationData = await this.approvalNotificationList.find(
      (data) => this.$route.params.id === data._id
    );
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

.status-header-wrapper {
  margin-bottom: 1.5rem;
}

.status-header {
  text-align: right;
  margin-right: 120px;
  margin-bottom: 0;
}

.status-approved {
  color: green;
  font-weight: 800;
}

.status-rejected {
  color: red;
  font-weight: 800;
}

.status-pending {
  color: blue;
  font-weight: 800;
}

.section-title-primary {
  color: var(--primary);
  margin-bottom: 1rem;
}

.criteria-details-row {
  align-items: flex-start;
}

.form-field-row {
  flex-wrap: wrap;
}

.form-label-fixed {
  min-width: 130px;
  flex-shrink: 0;
}

.form-label-medium {
  min-width: 100px;
  flex-shrink: 0;
}

.download-link-btn {
  flex: 1;
}

.hr-border-dashed-primary {
  border-top: 1px dashed var(--primary);
}

.template-config-row {
  align-items: flex-start;
}

.template-body-textarea {
  min-height: 100px;
  resize: vertical;
}

.approval-buttons-wrapper {
  padding: 1rem;
}

.approval-btn-reject,
.approval-btn-approve {
  min-width: 150px;
}

.status-display-btn {
  min-width: 120px;
}

@media (max-width: 991.98px) {
  .status-header {
    margin-right: 60px;
  }

  .form-label-fixed {
    min-width: 120px;
  }

  .form-label-medium {
    min-width: 90px;
  }
}

@media (max-width: 767.98px) {
  .status-header-wrapper {
    margin-bottom: 1rem;
  }

  .status-header {
    text-align: center;
    margin-right: 0;
    font-size: 1.125rem;
  }

  .section-title-primary {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }

  .form-field-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-label-fixed,
  .form-label-medium {
    min-width: auto;
    width: 100%;
    margin-bottom: 0.25rem;
    font-size: 0.9rem;
  }

  .download-link-btn {
    width: 100%;
  }

  .template-body-textarea {
    min-height: 80px;
  }

  .approval-buttons-wrapper {
    padding: 0.5rem;
  }

  .approval-btn-reject,
  .approval-btn-approve {
    min-width: auto;
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .status-header {
    font-size: 1rem;
  }

  .section-title-primary {
    font-size: 0.95rem;
  }

  .form-label-fixed,
  .form-label-medium {
    font-size: 0.85rem;
  }
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: var(--primary) !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
>
